enum Reducers {
  // ToDO: Legacy
  Ui = 'ui',
  Pages = 'pages', // We already have `DMSDocumentPages` state for this
  // End ToDO
  Accounts = 'accounts',
  AccountsManagement = 'accounts/management',
  AIChat = 'aiChat',
  AIChatPrompts = 'aiChat/prompts',
  Analytics = 'analytics',
  AppUi = 'app/ui',
  AppUIDialog = 'app/ui/dialog',
  AppUINotifications = 'app/ui/notifications',
  AppUIStatus = 'app/ui/status',
  Audit = 'audit',
  Auth = 'auth',
  AutomatedWorkflows = 'automatedWorkflows',
  AutomatedWorkflowsExecutions = 'automatedWorkflows/executions',
  BillingCharges = 'billing/charges',
  BillingInvoices = 'billing/invoices',
  BillingOrders = 'billing/orders',
  BillingPackages = 'billing/packages',
  BillingServices = 'billing/services',
  BillingSubscriptions = 'billing/subscriptions',
  BillingUsage = 'billing/usage',
  Calendar = 'calendar',
  CalendarEvents = 'calendarEvents',
  CalendarEventTypes = 'calendarEventTypes',
  CaseAlerts = 'case/alerts',
  CaseAssignments = 'case/assignments',
  CaseReports = 'case/reports',
  CaseShares = 'case/shares',
  Cases = 'cases',
  Clients = 'clients',
  Content = 'content',
  Conversations = 'conversations',
  CurrentUser = 'currentUser',
  DMS = 'documentManagementService',
  DMSBatches = 'documentManagementService/batches',
  DMSCollections = 'documentManagementService/collections',
  DMSDocumentPages = 'documentManagementService/document/pages',
  DMSDocuments = 'documentManagementService/documents',
  DMSDocumentsExports = 'documentManagementService/documents/exports',
  DMSUploads = 'documentManagementService/uploads',
  DocumentManagementService = 'documentManagementService',
  EpisodeAuthors = 'episode/authors',
  EpisodeFacts = 'episode/facts',
  Episodes = 'episodes',
  ExportTemplates = 'exportTemplates',
  Integrations = 'integrations',
  Invoices = 'invoices',
  LabellingToolAnnotations = 'labellingTool/annotations',
  LabellingToolJobs = 'labellingTool/jobs',
  Medical = 'medical',
  Messages = 'messages',
  Presenter = 'presenter',
  ReportPresets = 'report/presets',
  Requests = 'requests',
  Settings = 'settings',
  Subscriptions = 'subscriptions',
  Teams = 'teams',
  Templates = 'templates',
  Terms = 'terms',
  Users = 'users',
  UsersManagement = 'users/management',
  ManagementBillingUsage = 'management/billing/usage',
}

export default Reducers;
